import styled from "styled-components";
import { DataGrid } from "@mui/x-data-grid";

export const NoRowsOverlayWrap = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const CustomDataGrid = styled(DataGrid)`
  &.MuiDataGrid-root {
    border: none;
    width: 100%;
    height: calc(100vh - 230px);
    outline: none !important;
  }

  & div:focus {
    outline: none !important;
  }

  & .MuiDataGrid-cell:focus,
  .MuiDataGrid-cell:focus-within {
    outline: none !important;
  }

  & .Mui-selected {
    background-color: transparent !important;
  }

  & .Mui-checked {
    color: #6750a4 !important;
  }

  & .MuiDataGrid-columnHeaderTitle {
    font-weight: 700;
  }

  & .MuiDataGrid-row {
    min-height: 52px !important;
    max-height: fit-content !important;
    height: auto !important;
  }

  // & .MuiDataGrid-columnHeaders .MuiSvgIcon-root {
  //   display:none;
  // }

  & .MuiDataGrid-columnHeaders:first-child {
    justify-content: center !important;
    margin: 0 !important;
  }

  &
    .MuiDataGrid-columnHeader[data-field="number"]:first-child
    .MuiDataGrid-columnHeaderTitleContainer {
    justify-content: center !important;
    margin: 0 !important;
  }

  &
    .MuiDataGrid-columnHeader[data-field="number"]:first-child
    .MuiDataGrid-columnHeaderDraggableContainer {
    width: calc(100% - 10px) !important;
  }

  // & .MuiDataGrid-cell {
  //   min-height: 52px !important;
  //   max-height: fit-content !important;
  //   height: auto !important;
  //   padding: 6px !important;
  //   white-space: inherit !important;
  // }

  & .MuiButtonBase-root {
    color: #6a6a6a;
  }

  // & .MuiButtonBase-root[title="Menu"] {
  //   color: red;
  //   display: none;
  // }

  // & .columnHeader--filtered {
  //   color: red !important;
  // }

  & .MuiTablePagination-selectLabel,
  .MuiTablePagination-root,
  .MuiTablePagination-displayedRows {
    font-size: 12px !important;
  }

  & .hover-cursor-default:hover {
    cursor: default;
  }

  & .hover-cursor-point:hover {
    cursor: pointer;
  }
`;

export const StyleDataGrid = styled(DataGrid)`
  & .MuiDataGrid-iconSeparator {
    display: none !important;
  }

  /* GlobalStyles 가 모든 요소의 스크롤바를 숨기므로(* ::-webkit-scrollbar {display:none})
     그리드의 스크롤 영역에는 스크롤바를 직접 살려 둔다. 컬럼이 표 폭을 넘으면
     가로 스크롤바가 보여야 마우스 사용자도 오른쫁 컬럼으로 갈 수 있다.
     색은 AppContainer 의 세로 스크롤바와 맞춘다. */
  & .MuiDataGrid-virtualScroller {
    /* GlobalStyles 의 "* { scrollbar-width: none }" 을 되돌린다. thin 이나
       scrollbar-color 를 주면 Chrome 이 아래 ::-webkit-scrollbar 를 무시하고 macOS
       에서는 스크롤할 때만 보이는 오버레이로 그리므로 auto 로만 둔다. */
    scrollbar-width: auto;
  }
  & .MuiDataGrid-virtualScroller::-webkit-scrollbar {
    display: block;
    height: 10px;
    width: 10px;
  }
  & .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb {
    background-color: rgba(103, 80, 164, 0.6);
    border-radius: 5px;
    border: 2px solid transparent;
    background-clip: padding-box;
  }
  & .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover {
    background-color: rgba(103, 80, 164, 0.8);
  }
  & .MuiDataGrid-virtualScroller::-webkit-scrollbar-track {
    background: rgba(103, 80, 164, 0.06);
    border-radius: 5px;
  }

  & .MuiDataGrid-columnHeaders {
    background: #ccc;
  }

  & .MuiDataGrid-columnHeaders .MuiSvgIcon-root {
    // display: none;
  }

  &
    .MuiDataGrid-columnHeaders
    .MuiSvgIcon-root[data-testid="CheckBoxOutlineBlankIcon"],
  &
    .MuiDataGrid-columnHeaders
    .MuiSvgIcon-root[data-testid="IndeterminateCheckBoxIcon"],
  & .MuiDataGrid-columnHeaders .MuiSvgIcon-root[data-testid="CheckBoxIcon"] {
    display: block !important;
  }

  & .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon {
    // display: none !important;
  }

  &
    .MuiDataGrid-columnHeader[data-field="number"]:first-child
    .MuiDataGrid-columnHeaderTitleContainer {
    justify-content: center !important;
    margin: 0 !important;
  }

  &
    .MuiDataGrid-columnHeader:first-child
    .MuiDataGrid-columnHeaderTitleContainer {
    justify-content: center;
  }

  & .MuiButtonBase-root {
    color: #6a6a6a;
  }

  /* AI Review: vertically center ungrouped column headers across the
     doubled-height column header area created by columnGrouping.
     Assumes default MUI X v5 headerHeight=56. */
  & .MuiDataGrid-columnHeader.ai-ungrouped-header {
    margin-top: -56px;
    height: calc(100% + 56px) !important;
    align-items: center;
  }

  & .is-reviewer {
    background: #fce6cd !important;
  }
  & .is-rejected {
    background: #efefef !important;
  }
  & .is-published {
    background: #d0e1f3 !important;
  }
  /* 삭제된 템플릿(isDeleted=true) — 다른 상태색보다 우선 적용 */
  & .is-deleted {
    background: #f9d5d3 !important;
  }
  & .is-warning {
    background-color: red !important;
    animation: blink 1s infinite;
  }

  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
